<div class="custom-modal-layout">
  <div class="modal-header">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Email Icon" />
    </div>
    <span class="title">{{ isEditMode ? 'Editar' : 'Adicionar nova'}} empresa</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()" />
  </div>
  <form [formGroup]="institutionForm" (ngSubmit)="save()">
    <div class="p-fluid grid">
      <div class="field col-12">
        <div class="file-upload">
          <p-fileupload name="myfile[]" (onSelect)="onSelectedFiles($event)" [multiple]="false"
            accept="image/png, image/jpeg, image/jpg" maxFileSize="2000000000" invalidFileTypeMessageSummary="danger"
            invalidFileTypeMessageDetail="O Ficheiro seleccionado é inválido" invalidFileLimitMessageSummary="danger"
            invalidFileLimitMessageDetail="Ficheiro muito grande. Min: 2MB">
            <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
              let-uploadCallback="uploadCallback">
            </ng-template>
            <ng-template #content let-files let-uploadedFiles="uploadedFiles"
              let-removeFileCallback="removeFileCallback" let-chooseCallback="chooseCallback"
              let-removeUploadedFileCallback="removeUploadedFileCallback">
              <a class="circular-upload preview"
                [ngStyle]="{ 'background-image': imagePreview ? 'url(' + imagePreview + ')' : 'none' }">
                <span *ngIf="!imagePreview">Foto</span>
                <div class="icon" (click)="choose($event, chooseCallback)">
                  <img src="icons/camera-01.svg" alt="">
                </div>
              </a>
              <!-- <button pButton type="button" label="Guardar Foto" class="p-button-primary mt-2" (click)="savePhoto()"></button> -->
            </ng-template>
            <ng-template #file></ng-template>
            <ng-template #empty></ng-template>
          </p-fileupload>
        </div>
      </div>
      <div class="field col-12">
        <label for="NIF">NIF</label>
        <div class="flex align-items-center relative">
          <input id="NIF" type="search" class="w-full" pInputText formControlName="NIF" placeholder="Informe o NIF" />
          <button pButton type="button" icon="pi pi-search" class="search-btn" (click)="searchNif()"
            aria-label="Search"></button>
        </div>
        <div *ngIf="institutionForm.get('NIF')?.invalid && institutionForm.get('NIF')?.touched" class="error-message">
          NIF da empresa é obrigatório
        </div>
      </div>

      <div class="field col-12">
        <label for="name">Nome da empresa</label>
        <input id="Nome" type="text" class="w-full" pInputText formControlName="Nome" placeholder="Nome da empresa" />
        <div *ngIf="institutionForm.get('Nome')?.invalid && institutionForm.get('Nome')?.touched" class="error-message">
          Nome da empresa é obrigatório
        </div>
      </div>

      <div class="field col-6">
        <label for="email">Email</label>
        <input id="email" type="text" class="w-full" pInputText formControlName="Email" placeholder="Email" />
        <div *ngIf="institutionForm.get('Email')?.invalid && institutionForm.get('Email')?.touched"
          class="error-message">
          Email da empresa é obrigatório
        </div>
      </div>

      <div class="field col-6">
        <label for="Telefone">Telefone</label>
        <input id="Telefone" type="text" class="w-full" pInputText formControlName="Telefone" placeholder="Contacto" />
        <div *ngIf="institutionForm.get('Telefone')?.invalid && institutionForm.get('Telefone')?.touched"
          class="error-message">
          Telefone da empresa é obrigatório
        </div>
      </div>

      <div class="field col-12">
        <label for="Localizacao">Endereço</label>
        <input id="Localizacao" type="text" class="w-full" pInputText formControlName="Localizacao"
          placeholder="Endereço" />
        <div *ngIf="institutionForm.get('Localizacao')?.invalid && institutionForm.get('Localizacao')?.touched"
          class="error-message">
          Endereço da empresa é obrigatório
        </div>
      </div>

      <div class="field col-6">
        <label for="TipoEmpresa">Tipo de empresa</label>
        <p-select [filter]="true" id="TipoEmpresa" placeholder="Seleccione o tipo de empresa"
          formControlName="TipoEmpresa" class="w-full" [options]="tipoEmpresaOptions" optionLabel="designacao"
          optionValue="id" />
        <div *ngIf="institutionForm.get('TipoEmpresa')?.invalid && institutionForm.get('TipoEmpresa')?.touched"
          class="error-message">
          Tipo de empresa é obrigatório
        </div>
      </div>

      <div class="field col-6">
        <label for="EstadoContrato">Estado do contrato</label>
        <p-select [filter]="true" id="EstadoContrato" placeholder="Seleccione o estado do contrato"
          formControlName="EstadoContrato" class="w-full" [options]="estadoContratoOptions" optionLabel="designacao"
          optionValue="id" />
        <div *ngIf="institutionForm.get('EstadoContrato')?.invalid && institutionForm.get('EstadoContrato')?.touched"
          class="error-message">
          Estado do contrato da empresa é obrigatório
        </div>
      </div>

      <div class="field col-6">
        <label for="SubSector">Sub-Sector</label>
        <p-select [filter]="true" id="SubSector" class="w-full" [options]="subSectorOptions" optionLabel="designacao"
          optionValue="id" placeholder="Seleccione o subSector" formControlName="SubSector" />
        <div *ngIf="institutionForm.get('SubSector')?.invalid && institutionForm.get('SubSector')?.touched"
          class="error-message">
          Sub-Sector da empresa é obrigatório
        </div>
      </div>

      <div class="field col-6">
        <label for="url">Site da empresa (Opcional)</label>
        <input id="url" type="text" class="w-full" pInputText formControlName="URL"
          placeholder="Informe o site da empresa" />
      </div>
    </div>

    <div class="field col-12">
      <label for="desc">Descrição da empresa</label>
      <textarea id="desc" pTextarea class="w-full" formControlName="DescricaoEmpresa"
        placeholder="Adicione um texto sobre a sua empresa"></textarea>
    </div>

    <div class="modal-footer">
      <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button>
      <button pButton type="submit" [label]="isEditMode ? 'Actualizar' : 'Adicionar'" class="p-button-primary"></button>
    </div>
  </form>
</div>

<p-toast></p-toast>